import { IconButton } from '@mui/material';
import { VyIcon, type VyIconType } from '@vy/ui-design-system';
import { useCallback } from 'react';

type PhaseLabelChipIconButtonProps = {
  icon: VyIconType;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const PhaseLabelChipIconButton: React.FC<PhaseLabelChipIconButtonProps> = ({ icon, onClick }) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      onClick(event);
    },
    [onClick],
  );

  return (
    <IconButton size="small" onClick={handleClick}>
      <VyIcon icon={icon} />
    </IconButton>
  );
};
